var r = /* @__PURE__ */ ((o) => (o.FromNow = "#fromNow", o.Ordinal = "#ordinal", o.RoundDays = "#roundDays", o))(r || {}), t = /* @__PURE__ */ ((o) => (o.ApeironSite = "apeiron-official", o.ApeironSso = "apeiron-sso", o.BrandingSite = "foonie-magus", o.DoodiBrandingSite = "doodi-branding-site", o.DoodiCoinSite = "doodi-coin-site", o.Marketplace = "marketplace", o.MarketplacePolygon = "marketplace-polygon", o.PlanetMint = "planet-mint", o.Share = "share", o.StarMint = "star-mint", o.WebStore = "web-store", o.Backend = "backend", o))(t || {});
export {
  r as i18nFormat,
  t as i18nNamespace
};
//# sourceMappingURL=i18n.js.map
